export default __webpack_public_path__ + "static/media/whiteTriangularIcon.c51c1868.svg";